import { Vector3 } from "three";


export function isPointInsideBoundary(point: Vector3, center: XYZ, size: XYZ, inclusive: boolean = false) {
  const { x, y, z } = point;
  const [centerX, centerY, centerZ] = center;
  const [sizeX, sizeY, sizeZ] = size;
  const minX = centerX - sizeX / 2;
  const maxX = centerX + sizeX / 2;
  const minY = centerY - sizeY / 2;
  const maxY = centerY + sizeY / 2;
  const minZ = centerZ - sizeZ / 2;
  const maxZ = centerZ + sizeZ / 2;
  if (inclusive) {
    return (
      x >= minX && x <= maxX &&
      y >= minY && y <= maxY &&
      z >= minZ && z <= maxZ
    )
  }
  return (
    x > minX && x < maxX &&
    y > minY && y < maxY &&
    z > minZ && z < maxZ
  )
}